const FORMAT_LABELS: Record<string, string> = {
  pdf: 'PDF',
  word: 'Word',
  page: 'Web page',
};

/** Tools enum names are PascalCase or snake_case. The library does not keep a second label map. */
export function catalogLabel(value: string): string {
  const format = FORMAT_LABELS[value];
  if (format) return format;
  const spaced = value
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2')
    .trim();
  if (!spaced) return value;
  return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}
